// Usercentrics gibt den Tastaturfokus beim Schliessen nicht zurueck: der fokussierte Knoten wird
// mitsamt Dialog aus dem Shadow-Root entfernt, wodurch der Fokus auf <body> faellt.
(function() {
  if (window.consentFocusReturnReady) return;
  window.consentFocusReturnReady = true;

  const OPENER_SELECTOR = 'a[href="#uc-corner-modal-show"]';
  // Das href gehoert in den Selektor: die Produktseite rendert einen zweiten Skip-Link mit
  // derselben Klasse, aber anderem Ziel.
  const SKIP_LINK_SELECTOR = 'a.skip-to-content-link[href="#MainContent"]';
  const CMP_HOST_ID = 'usercentrics-cmp-ui';

  // Der Shim in snippets/usercentrics.liquid legt diesen Zustand vor dem async CMP-Loader an und
  // puffert alles, was vor diesem defer-Script passiert. Ohne Shim traegt das Asset sich selbst.
  const state =
    window.consentFocusReturn || (window.consentFocusReturn = { opener: null, events: [], drained: false });

  document.addEventListener(
    'click',
    function(event) {
      const clicked = event.target;
      const opener = clicked && clicked.closest ? clicked.closest(OPENER_SELECTOR) : null;
      if (opener) state.opener = opener;
    },
    true,
  );

  function isUsable(element) {
    if (!element || !element.isConnected || element.disabled) return false;
    if (element.hasAttribute('hidden')) return false;
    return element.getClientRects().length > 0;
  }

  // Ohne Opener wurde der Dialog automatisch geoeffnet; dann ist der Skip-Link der Anfang des Shops.
  function resolveTarget(opener) {
    if (isUsable(opener)) return opener;
    const skipLink = document.querySelector(SKIP_LINK_SELECTOR);
    if (isUsable(skipLink)) return skipLink;
    return document.getElementById('MainContent');
  }

  // "NONE -> NONE" feuert beim Oeffnen und darf nicht ausloesen. Welche Events ueberhaupt ankommen,
  // ist nicht garantiert, daher traegt der Uebergang allein das Signal.
  function isClosingTransition(detail) {
    const from = detail.previousView;
    return detail.view === 'NONE' && (from === 'FIRST_LAYER' || from === 'SECOND_LAYER');
  }

  // Fokus, den niemand bewusst gesetzt hat. Der CMP-Host zaehlt dazu: Fokus aus dessen Shadow-Root
  // wird auf den Host retargetet, und der bleibt im Dokument, auch wenn der Dialog schon weg ist.
  function isFocusUnclaimed() {
    const active = document.activeElement;
    if (!active || active === document.body || active === document.documentElement) return true;
    if (!active.isConnected) return true;
    const host = document.getElementById(CMP_HOST_ID);
    return !!host && (active === host || host.contains(active));
  }

  // Jedes UC-Ereignis entwertet eine noch schwebende Rueckgabe: der Dialog kann inzwischen wieder
  // offen sein, und dann haelt isFocusUnclaimed() den CMP-Host faelschlich fuer frei. Darum zaehlt
  // der Zaehler alle Ereignisse, nicht nur Schliessvorgaenge.
  let viewGeneration = 0;

  function restore(target) {
    const scheduled = viewGeneration;
    // Usercentrics entfernt den Dialog erst nach diesem Event; ein sofortiges focus() wuerde davon
    // wieder ueberschrieben.
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        if (scheduled !== viewGeneration) return;
        // Erst hier ist der Teardown durch. Frueher gepruefte Fokuslage waere noch der CMP-Host.
        if (!isFocusUnclaimed()) return;
        target.focus();
      });
    });
  }

  function handleClose() {
    const opener = state.opener;
    state.opener = null;
    const target = resolveTarget(opener);
    if (!target) return;
    restore(target);
  }

  // Nachgezogen wird nur, wenn das LETZTE gepufferte Ereignis selbst ein Schliessen ist. Sonst wurde
  // danach wieder geoeffnet — auch das leere "NONE -> NONE" gehoert zu einem Oeffnen — und die
  // Rueckgabe holte den Fokus aus dem offenen Dialog und verwuerfe den Opener.
  const buffered = state.events.splice(0);
  state.drained = true;
  const last = buffered[buffered.length - 1];
  if (last && isClosingTransition(last)) handleClose();

  window.addEventListener('UC_UI_VIEW_CHANGED', function(event) {
    const detail = event.detail || {};
    viewGeneration += 1;
    if (!isClosingTransition(detail)) return;
    handleClose();
  });
})();
